import React, { createContext, useContext, useRef, useCallback } from "react";

const ToastContext = createContext(null);

export const ToastProvider = ({ children, showToast }) => {
  const showToastRef = useRef(showToast);
  showToastRef.current = showToast;

  const stableShowToast = useCallback((...args) => {
    if (showToastRef.current) {
      showToastRef.current(...args);
    }
  }, []);

  return (
    <ToastContext.Provider value={stableShowToast}>
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};
